import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);


const datastore = new Vuex.Store({
    state: {
        count: 0,
        user: null,
        logged_in: false
    },
    mutations: {
        increment(state) {
            state.count++;
        },
        setUser(state, user) {
            state.user = user
        },
        login(state, user) {
            state.user = user;
            state.logged_in = true;
        }
    }
})


export default datastore;